import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E3TransactionsEdit } from "./edit";
import { E3TransactionsNew } from "./new";
import { E3TransactionsTable } from "./table";

export default function E3Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E3TransactionsEdit />} />
      <Route index element={<E3TransactionsTable />} />
      <Route path="/new" element={<E3TransactionsNew />} />
    </Routes>
  );
}
